import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'login',
      beforeEnter: function(to, from, next) {
        let ua = window.navigator.userAgent.toLowerCase()
        console.log('ua', ua)
        console.log('to', to)
        let isWechat = ua.indexOf('micromessenger') > 0
        if (isWechat) {
          if (to.query.openId) {
            next()
          } else {
            if (to.query.to) {
              window.$cache.set('to', to.query.to)
            }
            if (to.query.q) {
              window.$cache.set('to', 'quit')
            }
            location.assign(process.env.SERVER_API+'/api/wechat/authorize?type=1&returnUrl=' + encodeURIComponent(process.env.BASE_API + '/wxAuth'))
            next(false)
          }
        } else {
          next()
        }
      },
      component: () => import('@/views/Login').then(m => m.default)
    },
    {
      path: '/wxAuth',
      name: 'wxAuth',
      component: () => import('@/views/WxAuth').then(m => m.default)
    },
    {
      path: '/home',
      name: 'home',
      beforeEnter: function(to, from, next) {
        let user = window.$cache.get('user')
        if (user) {
          next()
        } else {
          window.location.href = '/?to=/home'
        }
      },
      meta: {
        title: ''
      },
      component: () => import('@/views/Home').then(m => m.default)
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      beforeEnter: function(to, from, next) {
        let user = window.$cache.get('user')
        if (user) {
          next()
        } else {
          window.location.href = '/?to=/withdraw'
        }
      },
      meta: {
        title: ''
      },
      component: () => import('@/views/withdraw/withdraw').then(m => m.default)
    },
    {
      path: '/income',
      name: 'income',
      beforeEnter: function(to, from, next) {
        let user = window.$cache.get('user')
        if (user) {
          next()
        } else {
          window.location.href = '/?to=/income'
        }
      },
      meta: {
        title: ''
      },
      component: () => import('@/views/income/income').then(m => m.default)
    },
    {
      path: '/history',
      name: 'history',
      beforeEnter: function(to, from, next) {
        let user = window.$cache.get('user')
        if (user) {
          next()
        } else {
          window.location.href = '/?to=/history'
        }
      },
      meta: {
        title: ''
      },
      component: () => import('@/views/history/history').then(m => m.default)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js